<template>
	<!-- Модал принятия решения -->
	<b-modal
	:lazy="true"
	disabled
	ref="modal"
	size="md"
	header-class="py-2 px-3"
	footer-class="d-flex justify-content-between gap-2"
	title-tag="h6"
	no-close-on-esc
	no-close-on-backdrop
	body-class="p-0"
	@show="onModalShown"
	@hidden="onModalHidden"
	show
	>

		<div slot="modal-title">
			Добавить решение {{ applicationId ? 'по заявке' : (projectId ? 'по проекту' : '') }}
		</div>

		<loading-panel
		class="bg-light mt-2"
		v-if="isFetching"
		/>

		<!-- Вариант модального окна для добавления решения по Заявке или по Проекту -->
		<div class="bg-light px-2" :class="{'border-bottom pt-3': fields.review_status, 'py-3': !fields.review_status}">
			<div class="d-flex justify-content-around">
				<ul class="nav nav-tabs card-header-tabs px-0 m-0">
					<li class="nav-item">
						<a
						v-if="isAcceptable"
						href="#"
						:class="{
							'active': fields.review_status == 'Согласован',
							'btn btn-light border mr-2': !fields.review_status,
							'nav-link': fields.review_status
						}"
						@click="fields.review_status = 'Согласован'"
						>
							<span class="fa-regular fa-check fa-fw mr-1 text-success"></span>
							Согласовать
						</a>
					</li>
					<li class="nav-item">
						<a
						v-if="isDeclinable"
						href="#"
						:class="{
							'active': fields.review_status == 'Отклонен',
							'btn btn-light border': !fields.review_status,
							'nav-link': fields.review_status
						}"
						@click="fields.review_status = 'Отклонен'"
						>
							<span class="fa-regular fa-ban fa-fw mr-1 text-danger"></span>
							Отклонить
						</a>
					</li>
				</ul>
			</div>
		</div>

		<!-- Вариант полей модального окна только для добавления решения по Заявлению или по Согласованию -->
		<div class="px-3" v-if="fields.review_status">
			<div class="row">
				<div class="col-6">
					<card-field-component
					type="date"
					title="Дата исходящего"
					fieldname="review_outgoing_date"
					:errors="errors"
					v-model="fields.review_outgoing_date"
					:display-value="fields.review_outgoing_date"
					:disabled="isSending"
					mode="edit"
					v-on:update:value="fields.review_outgoing_date = $event"
					:is-required="true"
					/>
				</div>
				<div class="col-6">
					<card-field-component
					type="text"
					title="Номер согласования"
					fieldname="review_title"
					:errors="errors"
					v-model="fields.review_title"
					:display-value="fields.review_title"
					:disabled="isSending"
					mode="edit"
					v-on:update:value="fields.review_title = $event"
					:is-required="true"
					/>
				</div>
				<div class="col-12">
					<card-field-component
					type="filebase64"
					title="Файл решения"
					fieldname="file"
					file-types=".pdf"
					:errors="errors"
					v-model="fields.file"
					:disabled="isSending"
					mode="edit"
					v-on:update:value="fields.file = $event"
					:is-required="true"
					/>
					<card-field-component
					v-if="isSigRequired"
					type="filebase64"
					title="Электронная подпись"
					fieldname="sig"
					file-types=".sig"
					:errors="errors"
					v-model="fields.sig"
					:disabled="isSending"
					mode="edit"
					v-on:update:value="fields.sig = $event"
					:is-required="true"
					/>
				</div>
			</div>
		</div>

		<template slot="modal-footer">
			<button
			type="button"
			@click.prevent="$refs.modal.hide()"
			:disabled="isSending"
			class="btn btn-light border"
			>
				Отмена
			</button>

			<button
			v-if="fields.review_status"
			type="button"
			@click.prevent="$refs.confirmModal.show()"
			:disabled="isSending || !isFormReady"
			:class="'btn btn-success ' + (fields.review_status == 'Согласован' ? 'btn-success' : 'btn-danger')"
			>
				<template v-if="fields.review_status == 'Согласован'">
					Согласовать
				</template>
				<template v-else-if="fields.review_status == 'Отклонен'">
					Отклонить
				</template>
			</button>
		</template>

		<!-- Модал подтверждения -->
		<b-modal
		:lazy="true"
		disabled
		ref="confirmModal"
		size="md"
		header-class="py-2 px-3"
		footer-class="d-flex justify-content-between gap-2"
		title-tag="h6"
		no-close-on-esc
		no-close-on-backdrop
		body-class="p-0"
		show
		>
			<div slot="modal-title">
				Подтверждение действия
			</div>
			<div class="p-3">

				<p>Данное действие необратимо! Пожалуйста, убедитесь в правильности данного действия и, если необходимо, проверьте правильность заполнения полей.</p>

				<template v-if="applicationType == 'corr'">
					<p v-if="relatedApplicationNumber">Заявка будет принята и прикреплена к заявке с номером {{ relatedApplicationNumber }}.</p>
					<p v-else>Не найдено решение по заявке или заявка, на которую направлены правки, но вы всё ещё можете вернуться и отклонить заявку по формальным причинам.</p>
				</template>

			</div>
			<template slot="modal-footer">
				<button
				type="button"
				@click.prevent="$refs.confirmModal.hide()"
				:disabled="isSending"
				class="btn btn-light border"
				>
					Отмена
				</button>
				<button
				type="button"
				@click.prevent="$refs.confirmModal.hide(); submit()"
				:disabled="isSending"
				:class="'btn btn-success ' + (fields.review_status == 'Согласован' ? 'btn-success' : 'btn-danger')"
				>
					<template v-if="fields.review_status == 'Согласован'">
						Подтвердить согласование
					</template>
					<template v-else-if="fields.review_status == 'Отклонен'">
						Подтвердить отклонение
					</template>
				</button>
			</template>
		</b-modal>

	</b-modal>
</template>

<script>
	export default {
		props: [
			'projectId',
			'applicationId'
		],
		data () {
			return {
				isFetching: false,
				isSending: false,
				isAcceptable: false,
				isDeclinable: false,
				isSigRequired: false,
				applicationType: '',
				relatedApplicationNumber: null,
				errors: [],
				fields: {
					review_status: null, // Согласован | Отклонен
					review_outgoing_date: null,
					review_title: null,
					file: null,
					sig: null
				}
			}
		},
		methods: {
			openModal () {
				this.$refs.modal.show()
			},
			/**
			 * При открытии модала запустить запрос проверки вариантов добавления решений
			 */
			onModalShown () {
				this.fetch()
			},
			/**
			 * Сброить локальные переменные при закрытии модала
			 */
			onModalHidden () {
				
				this.isFetching = false
				this.isSending = false
				this.isAcceptable = false
				this.isDeclinable = false
				this.isSigRequired = false

				this.applicationType = '',
				this.relatedApplicationNumber = null

				let keys = Object.keys(this.fields)
				for (var i = keys.length - 1; i >= 0; i--) {
					this.fields[keys[i]] = null
				}

				this.errors =  []
			},
			/**
			 * Запросить у сервера ответ о возможностях
			 * одобрения/отклонения и необходимости добавления подписи
			 */
			fetch () {
				if (this.isFetching) {
					return false
				}

				this.isFetching = true

				this
					.$http
					.post(process.env.VUE_APP_API_ROOT + '/api/reviews/check', {
						project_id: this.projectId,
						application_id: this.applicationId,
					})
					.then(res => {
						this.isAcceptable = res.data.is_acceptable
						this.isDeclinable = res.data.is_declinable
						this.isSigRequired = res.data.is_sig_required

						this.applicationType = res.data.application_type
						this.relatedApplicationNumber = res.data.related_application_number

					})
					/**
					 * Обработка ошибок
					 */
					.catch(error => {
						const errorText = error && error.response && error.response.data ? (error.response.data.status ? error.response.data.status : (error.response.data.error ? error.response.data.error : 'Неизвестная ошибка')) : 'Неизвестная ошибка'
						/*
						 * Ошибка: Отобразить содержимое ответа в виде
						 * всплывающего сообщения об ошибке
						 */
						this.$notify({
							group: 'main',
							text: 'Ошибка: ' + errorText,
							duration: 3000,
							type: 'alert-danger'
						})
						
					})
					.then(() => {
						this.isFetching = false
					})
			},
			/**
			 * Метод принятия заявления или согласования, отправка данных на сервер
			 * и обработка ответов
			 */
			submit () {
				if (this.isSending) {
					return false
				}
				this.isSending = true

				let data = this.fields
				data.project_id = this.projectId
				data.application_id = this.applicationId
				
				this
					.$http
					.post(process.env.VUE_APP_API_ROOT + '/api/reviews/review', data)
					.then(res => {
						if (res.data.status === 'success') {
							this.$refs.modal.hide()
							this.$emit('refetch')
							this.$notify({
								group: 'main',
								text: 'Решение было успешно добавлено!',
								duration: 6000,
								type: 'alert-success'
							})
						}
					})
					/**
					 * Обработка ошибок
					 */
					.catch(error => {
						const errorStatus = error && error.response && error.response.status ? error.response.status : null
						const errorText = error && error.response && error.response.data ? (error.response.data.status ? error.response.data.status : (error.response.data.error ? error.response.data.error : 'Неизвестная ошибка')) : 'Неизвестная ошибка'
						/**
						 * Если ошибки в полях (код 422) то назначить ответ в поле errors формы,
						 * чтобы отобразить ошибки под полями
						 */
						if (errorStatus == 422) {
							this.errors = error.response.data
							this.$notify({
								group: 'main',
								text: error.response.data.error ? error.response.data.error : 'Проверьте правильность заполнения полей',
								duration: 3000,
								type: 'alert-danger'
							})
						}
						/**
						 * Если код ошибки не 422, то просто отобразить содержимое ответа в виде
						 * всплывающего сообщения об ошибке
						 */
						else {
							this.$notify({
								group: 'main',
								text: 'Ошибка: ' + errorText,
								duration: 3000,
								type: 'alert-danger'
							})
						}
						
					})
					.then(() => {
						this.isSending = false
					})
			},
		},
		computed: {
			isFormReady () {
				return this.fields.review_outgoing_date && this.fields.review_title && this.fields.file && (this.isSigRequired ? !!this.fields.sig : true)
			},
		}
	}
</script>